import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {RefundCompletedDTO, RefundRequestDTO} from '@features/payment/domain/model/refund.model';
import {RefundStrategy} from '@features/payment/domain/ports/strategy/refund-strategy.port';
import {WalletsGateway} from '@features/payment/infrastructure/gateways/wallets.gateway';

@Injectable({providedIn: 'root'})
export class WalletRefundStrategy implements RefundStrategy {
  private readonly walletsGateway = inject(WalletsGateway);

  refund(request: RefundRequestDTO): Observable<RefundCompletedDTO> {
    return this.walletsGateway.refund(request);
  }
}
